import { isTimestampAfterCurrentDate } from "../helpers/datetimeHelper";
export function validEarningLoyalityRoles(LoyalityRoles, storeZone) {
  let validLoyalityRoles = LoyalityRoles.filter(
    pt =>
      !pt.Disabled &&
      (!pt.ExpiredDate || isTimestampAfterCurrentDate(pt.ExpiredDate.seconds, storeZone))
  );
  return validLoyalityRoles;
}
export function calcLoyaltyPoints(LoyalityRoles, price, rewardPoint) {
  var tempPrice = price;
  if (typeof rewardPoint === "undefined" || rewardPoint === 0) {
    var temppoint = 0;
    LoyalityRoles.forEach((roll) => {
      if (tempPrice >= roll.DollarSpent) {
        temppoint += Math.floor(tempPrice / roll.DollarSpent) * roll.Point;
        tempPrice = tempPrice % roll.DollarSpent;
      }
    });
    return temppoint;
  }
  return rewardPoint;
}
